/* ============================================
   PushSubscriptionManager — Global push subscription
   
   Auto-subscribes to Web Push notifications for
   both desktop and mobile layouts. Shows a dismiss-
   able banner when permission hasn't been asked yet.
   ============================================ */
import { useEffect, useState } from 'react'
import { usePushNotifications } from '@/hooks/usePushNotifications'

export default function PushSubscriptionManager() {
  const push = usePushNotifications()
  const [showBanner, setShowBanner] = useState(false)
  const [dismissed, setDismissed] = useState(() => {
    try { return sessionStorage.getItem('push-banner-dismissed') === '1' } catch { return false }
  })

  useEffect(() => {
    if (push.loading || !push.isSupported || dismissed) return

    if (push.permission === 'granted' && !push.isSubscribed) {
      // Already granted — subscribe silently
      push.subscribe()
    } else if (push.permission === 'default') {
      // Not asked yet — show banner after 3s
      const t = setTimeout(() => setShowBanner(true), 3000)
      return () => clearTimeout(t)
    }
  }, [push.loading, push.isSupported, push.permission, push.isSubscribed, dismissed])

  async function handleEnable() {
    setShowBanner(false)
    await push.subscribe()
  }

  function handleDismiss() {
    setShowBanner(false)
    setDismissed(true)
    try { sessionStorage.setItem('push-banner-dismissed', '1') } catch { /* ignore */ }
  }

  if (!showBanner) return null

  return (
    <div className="push-banner" id="push-notification-banner">
      <div className="push-banner__content">
        <span className="push-banner__icon">🔔</span>
        <span className="push-banner__text">
          Activa las notificaciones para recibir alertas de nuevos mensajes de WhatsApp
        </span>
      </div>
      <div className="push-banner__actions">
        <button
          className="push-banner__btn push-banner__btn--enable"
          onClick={handleEnable}
          type="button"
        >
          Activar
        </button>
        <button
          className="push-banner__btn push-banner__btn--dismiss"
          onClick={handleDismiss}
          type="button"
        >
          Ahora no
        </button>
      </div>
    </div>
  )
}
